import { useAppSelector } from '@common/hooks/store';
import { userLoggedIn } from '@features/auth/slice/authSlice';
import React, { Fragment, PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PrivateRoute(props: PropsWithChildren) {
  const navigate = useNavigate();
  const isAuth = useAppSelector(userLoggedIn);

  useEffect(() => {
    if (!isAuth) {
      navigate('/sign-in', { replace: true });
    }
  }, [ isAuth, navigate ]);

  if (!isAuth) {
    return null;
  }
  return <Fragment>{props.children}</Fragment>;
}
